import axios from 'axios'
import ConfigAPI from '@/config/api'
import Session from '@/handler/session'

const instance = axios.create();

function appendParams(url, data) {
  var params = []
  for (var key in data) {
    if (data[key] !== null && data[key] !== undefined && data[key] !== '') {
      params.push(encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
    }
  }
  return params.length ? url + '&' + params.join('&') : url
}

function taskFormData(data, images) {
  var formData = new FormData()

  for (var key in data) {
    if (key !== 'images') {
      formData.append(key, data[key] === null || data[key] === undefined ? '' : data[key])
    }
  }

  var files = images || []
  files.forEach((value, key) => {
    formData.append('images_' + key, value && value.path ? value.path : value)
  })
  formData.append('images', files.length)

  return formData
}

const servicesAPI = {
  obtenerTareas(filters = {}) {
    var url = appendParams(ConfigAPI.baseURL + "tasks" + Session.getToken(), filters)
    return instance.get(url);
  },
  obtenerOpciones(filters = {}) {
    var url = appendParams(ConfigAPI.baseURL + "tasks/options" + Session.getToken(), filters)
    return instance.get(url);
  },
  agregarTarea(data, images = []) {
    var headers = {
      'Content-Type': 'multipart/form-data'
    }
    var url = ConfigAPI.baseURL + "tasks" + Session.getToken();
    return instance.post(url, taskFormData(data, images), { headers });
  },
  editarTarea(id, data, images = null) {
    var url = ConfigAPI.baseURL + "tasks/" + id + Session.getToken();
    if (images === null) return instance.post(url, data);

    var headers = {
      'Content-Type': 'multipart/form-data'
    }
    return instance.post(url, taskFormData(data, images), { headers });
  },
  moverTarea(id, direction) {
    var url = ConfigAPI.baseURL + "tasks/" + id + "/move" + Session.getToken();
    return instance.post(url, { direction });
  },
  completarTarea(id) {
    var url = ConfigAPI.baseURL + "tasks/" + id + "/complete" + Session.getToken();
    return instance.post(url);
  },
  archivarTarea(id) {
    var url = ConfigAPI.baseURL + "tasks/" + id + "/archive" + Session.getToken();
    return instance.post(url);
  },
  restaurarTarea(id) {
    var url = ConfigAPI.baseURL + "tasks/" + id + "/restore" + Session.getToken();
    return instance.post(url);
  },
  eliminarTarea(id) {
    var url = ConfigAPI.baseURL + "tasks/" + id + Session.getToken();
    return instance.delete(url);
  },
  eliminarRecordatorio(id) {
    var url = ConfigAPI.baseURL + "reminders/" + id + Session.getToken();
    return instance.delete(url);
  },
}

export default servicesAPI;
